import './App.css';
import { Routes, Route } from "react-router-dom"
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DashboardAkun from "./pages/dashboard/Akun";
import DashboardDataKaryawan from "./pages/dashboard/DataKaryawan"
import NotFound404 from './pages/404';
import HomeMobile from './pages/mobile/Home';
import LoginPage from './pages/mobile/LoginPage';
import Profile from './pages/mobile/Profile';

function App() {
  return (
    <>
      {/* Menu navigasi */}
      {/* Routing */}
      <Routes>
        {/* <Route path="/" element={<LoginPage />} /> */}
        {/* <Route path="/apps/mobile" element={<HomeMobile />} /> */}
        {/* <Route path="/apps/mobile/profile" element={<Profile />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard SideBar={[]} />} />
        {/* </Route> */}

        

        <Route path="*" element={ <NotFound404 /> } />
      </Routes>
    </>
  );
}

export default App;
